import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

const Blogs = function () {
  return (
    <AbstractCollection
      collectionName="Blogs"
      singleCollectionName="Blog"
      notToShow={[
        'ancestorIds',
        'parentId',
        'images',
        'videos',
        'type',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'coverPhoto', 'status', 'featured', 'createdAt']}
      type={typeConstant.BLOG}
    />
  )
}
export default Blogs
